import React from "react";
import Box from "@mui/material/Box";
import Card from "@mui/material/Card";
import CardContent from "@mui/material/CardContent";
import Typography from "@mui/material/Typography";
import ArrowUpwardIcon from "@mui/icons-material/ArrowUpward";
import ArrowDownwardIcon from "@mui/icons-material/ArrowDownward";
import { formatCount } from "../../../utils/formatCount";

export function AnalyticsCard({ title, value, icon: Icon, trend }) {
  const isPositive = trend >= 0;
  const displayValue = typeof value === "number" ? formatCount(value, "—") : (value ?? "—");

  return (
    <Card
      sx={{
        height: "100%",
        borderRadius: "24px",
        backgroundColor: "#FFF",
        boxShadow: "3px 2px 20px 0px rgba(0,0,0,0.04)",
      }}
    >
      <CardContent>
        {Icon && (
          <Box
            sx={{
              width: 44,
              height: 44,
              borderRadius: "12px",
              bgcolor: "#e8f5f0",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              color: "#065F46",
              mb: 1,
            }}
          >
            <Icon fontSize="medium" />
          </Box>
        )}
        <Typography
          variant="h4"
          sx={{ fontWeight: 700, color: "#362B24", fontFamily: "Heebo", wordBreak: "break-word" }}
        >
          {displayValue}
        </Typography>
        <Typography
          variant="body2"
          sx={{ color: "#362B24", opacity: 0.6, fontFamily: "Heebo" }}
        >
          {title}
        </Typography>
        {trend !== undefined && trend !== null && (
          <Box
            sx={{
              display: "flex",
              alignItems: "center",
              gap: 0.5,
              mt: 1,
              color: isPositive ? "#065F46" : "#EA001B",
            }}
          >
            {isPositive ? <ArrowUpwardIcon fontSize="small" /> : <ArrowDownwardIcon fontSize="small" />}
            <Typography variant="caption" fontWeight={600} fontFamily="Heebo">
              {Math.abs(trend)}%
            </Typography>
          </Box>
        )}
      </CardContent>
    </Card>
  );
}
